<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->
      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">ご請求案内</h1>
          </div>
          <div class="contract-container">
            <!-- <div v-if="state.initialize" class="license-content">
            </div> -->
            <div class="contract-content">

              <FontawesomeIcon v-if="!group1.isApplicationHistoryLoaded && !group1.isInvoicelistLoaded" 
                :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>

                <div class="package">
                  <div class="tbl01">
                    <table class="tbl">
                      <colgroup>
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>パッケージ名</th>
                          <th>契約期間</th>
                          <th>決済方法</th>
                          <th>次年度継続時の決済方法</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in group1.packageList" :key="'package_list_' + index">
                          <td>{{ item.packageName }}</td>
                          <td>{{ item.periodStart }}～{{ item.periodEnd }}</td>
                          <td>{{ item.payment }}</td>
                          <td>{{ item.next_payment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <template v-if="group1.authorization">
                  <div class="contractDetail">
                    <div class="tbl01">
                      <table class="tbl">
                        <thead>
                          <tr>
                            <th>請求年月</th>
                            <th>申込No</th>
                            <th>申込内容</th>
                            <th>お支払い方法</th>
                            <th>請求書</th>
                            <th>お支払い年月日</th>
                            <th>お支払い明細</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(item, index) in group1.invoiceList">
                            <tr v-for="(item2, index2) in item.list" :key="'invoice_list_' + index + '_' + index2">
                              <template v-if="index2 === 0">
                                <td :rowspan="item.rowspan">{{ item2.exec_month }}</td>
                                <td :rowspan="item.rowspan">
                                  <p v-for="(item3, index3) in item2.list_no" :key="'list_no_' + index + '_' + index2 + '_' + index3">{{ item3 }}</p>
                                </td>
                                <td :rowspan="item.rowspan">
                                  <p v-for="(item3, index3) in item2.list_content" :key="'list_no_' + index + '_' + index2 + '_' + index3">{{ item3 }}</p>
                                </td>
                                <td :rowspan="item.rowspan">
                                  <p v-for="(item3, index3) in item2.list_payment_method" :key="'list_no_' + index + '_' + index2 + '_' + index3">{{ item3 }}</p>
                                </td>
                                <td :rowspan="item.rowspan">
                                  <template v-if="item2.exist_web_invoice">
                                    <a @click.prevent="group1.openWebInvoice(item2.web_invoice_no)" class="txt-blue" role="button">請求書(PDF)</a>
                                  </template>
                                </td>
                              </template>
                              <td>
                                <template v-if="item2.usage_invoice_status === 8">－</template>
                                <template v-else>
                                  {{ item2.date }}
                                </template>
                              </td>
                              <td>
                                <template v-if="item2.usage_invoice_status === 8">－</template>
                                <template v-else-if="item2.exist_usage_invoice">
                                  <a @click.prevent="group1.openUsageInvoice(item2.usage_invoice_no)" class="txt-blue" role="button">お支払い明細(PDF)</a>
                                </template>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'

import * as logicContractInvoicingInformation from '@/logic/contract/ContractInvoicingInformation'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu
  },
  setup (props, context) {

    const { group1, state } = logicContractInvoicingInformation.getGroup(props, context)

    return {
      group1,
      state
    }
  }
})

</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
  }
  .tbl01 .tbl {
    border-top: none;
  }
  .package{
    .tbl01 .tbl {
      td{
        border-top: none;
      }
    }
    .txt-sup {
      margin-top: 10px;
    }
  }
  .contractDetail{
    margin-top: 40px;
    .tbl01 .tbl td{
      vertical-align: top;
    }
  }
}


</style>
